import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/layout/index.vue'),
    redirect: '/serverTree',
    children: [
      {
        path: '/publishList',
        name: 'publishList',
        component: () => import('@/views/publishList/publishList.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'creatStory',
        name: 'creatStory',
        component: () => import('@/views/creatStory/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'serverTree',
        name: 'serverTree',
        component: () => import('@/views/serverTree/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'logoMannge',
        name: 'logoMannge',
        component: () => import('@/views/logoMannge/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'metricsConfig',
        name: 'metricsConfig',
        component: () => import('@/views/metricsConfig/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'workorderConfig',
        name: 'workorderConfig',
        component: () => import('@/views/metricsConfig/workorderConfig.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'dataUpload',
        name: 'dataUpload',
        component: () => import('@/views/dataUpload/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'reportManage',
        name: 'reportManage',
        component: () => import('@/views/reportManage/index.vue'),
        meta: {
          openType: 1,
        },
      },
      {
        path: 'customerVoice',
        name: 'customerVoice',
        component: () => import('@/views/customerVoice/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'dataBord',
        name: 'dataBord',
        component: () => import('@/views/dataBord/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: 'largeScreenConfig',
        name: 'largeScreenConfig',
        component: () => import('@/views/largeScreenConfig/index.vue'),
        meta: {
          openType: 0,
        },
      },
      {
        path: '404page',
        name: '404page',
        component: () => import('@/views/error.vue'),
      },
      {
        path: 'supplierList',
        name: 'supplierList',
        component: () => import('@/views/supplierList/index.vue'),
        meta: {
          openType: 1,
        },
      },
      {
        path: '/supplierList/edit',
        name: '/supplierList/edit',
        component: () => import('@/views/supplierList/edit.vue'),
        meta: {
          openType: 1,
        },
      },
    ],
  },
  {
    path: '/index',
    redirect: '/serverTree',
  },
  {
    path: '/serviceReport',
    name: 'reportHtml315',
    component: () => import('@/views/mobile/reportHtml315/index.vue'),
    meta: {
      title: '物业服务报告',
      white: true,
    },
  },
  {
    path: '/serviceDetail',
    name: 'serviceDetail',
    component: () => import('@/views/mobile/reportHtml315/detail.vue'),
    meta: {
      title: '物业服务报告',
      white: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/mobile/reportHtml315/login.vue'),
    meta: {
      title: '登录',
      white: true,
    },
  },
  {
    path: '/selectProject',
    name: 'selectProject',
    component: () => import('@/views/mobile/reportHtml315/selectProject.vue'),
    meta: {
      title: '请选择你所在的小区',
      white: true,
    },
  },
  {
    path: '/zerFinace',
    name: 'zerFinace',
    component: () => import('@/views/mobile/reportHtml315/zerFinace.vue'),
    meta: {
      title: '公共资源经营情况',
      white: true,
    },
  },
  {
    path: '/serviceReport/device_detail',
    name: 'device_detail',
    component: () =>
      import('@/views/mobile/reportHtml315/components/deciceDT/detail.vue'),
    meta: {
      title: '电梯设备明细',
      white: true,
    },
  },
  {
    path: '/serviceReport/updateDetail',
    name: 'updateDetail',
    component: () =>
      import('@/views/mobile/reportHtml315/components/microUpdates/list.vue'),
    meta: {
      title: '',
      white: true,
    },
  },
  {
    path: '/serviceReport/lightDetail',
    name: 'lightDetail',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/LightupAction/components/lightList.vue'
      ),
    meta: {
      title: '小区点亮工程改造详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/lightupdateDetail',
    name: 'lightupdateDetail',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/LightupAction/components/updateDetail.vue'
      ),
    meta: {
      title: '设备设施焕新详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/qualityControlDetail',
    name: 'qualityControlDetail',
    component: () =>
      import('@/views/mobile/reportHtml315/components/qualityControl/list.vue'),
    meta: {
      title: '已整改问题列表',
      white: true,
    },
  },
  {
    path: '/serviceReport/qualityControlSop',
    name: 'qualityControlSop',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/qualityControl/stepDetail.vue'
      ),
    meta: {
      title: '工单详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/stepDetail',
    name: 'stepDetail',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/microUpdates/stepDetail.vue'
      ),
    meta: {
      title: '工单详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/fance_detail',
    name: 'fance_detail',
    component: () =>
      import('@/views/mobile/reportHtml315/components/finance/detail.vue'),
    meta: {
      title: '小区公共收益明细',
      white: true,
    },
  },
  {
    path: '/serviceReport/fance_source',
    name: 'fance_source',
    component: () =>
      import('@/views/mobile/reportHtml315/components/finance/source.vue'),
    meta: {
      title: '了解公共资源',
      white: true,
    },
  },
  {
    path: '/serviceReport/deviceDetail',
    name: 'deviceDetail',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/dailyOperation/deviceDetail.vue'
      ),
    meta: {
      title: '设备设施巡检保养详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/deviceDetail3',
    name: 'deviceDetail3',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/dailyOperation/deviceDetail3.vue'
      ),
    meta: {
      title: '设备设施巡检保养详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/deviceDetail4',
    name: 'deviceDetail4',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/dailyOperation/deviceDetail4.vue'
      ),
    meta: {
      title: '设备设施巡检保养详情',
      white: true,
    },
  },
  {
    path: '/serviceReport/fireDetail',
    name: 'fireDetail',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/dailyOperation/fireDetail.vue'
      ),
    meta: {
      title: '',
      white: true,
    },
  },
  {
    path: '/serviceReport/dailyOperationlist',
    name: 'dailyOperationlist',
    component: () =>
      import('@/views/mobile/reportHtml315/components/dailyOperation/list.vue'),
    meta: {
      title: '',
      white: true,
    },
  },
  {
    path: '/serviceReport/equipment_workOrder',
    name: 'reportHtml315__equipment_workOrder',
    component: () =>
      import(
        '@/views/mobile/reportHtml315/components/dailyOperation/workOrderDes.vue'
      ),
    meta: {
      title: '工单详情',
      white: true,
    },
  },
  {
    path: '/default',
    name: 'default',
    component: () => import('@/views/mobile/reportHtml315/default.vue'),
    meta: {
      title: '物业服务报告',
      white: true,
    },
  },
  // 供方服务报告-客服
  {
    path: '/supplierCrm',
    name: 'supplierCrm',
    component: () => import('@/views/mobile/supplierCrm/index.vue'),
    meta: {
      title: '供方服务报告-客服',
      white: true,
      keepAlive: true,
    },
  },
  {
    path: '/supplierCrm/contractDetail',
    component: () =>
      import('@/views/supplierList/supplierCrm/contractDetail.vue'),
    meta: {
      title: '本月履约详情',
      white: true,
    },
  },
  {
    path: '/supplierCrm/contractSubDetail',
    component: () =>
      import('@/views/supplierList/supplierCrm/contractSubDetail.vue'),
    meta: {
      title: '履约明细详情',
      white: true,
    },
  },
  {
    path: '/supplierCrm/businessHandlingDetail',
    component: () =>
      import('@/views/supplierList/supplierCrm/BusinessHandlingDetail.vue'),
    meta: {
      title: '业务办理详情',
      white: true,
    },
  },
  {
    path: '/supplierCrm/complaintDetail',
    component: () =>
      import('@/views/supplierList/supplierCrm/complaintDetail.vue'),
    meta: {
      title: '客户有效投诉列表',
      white: true,
    },
  },
  // 供方服务报告-万净
  {
    path: '/supplierClean',
    name: 'supplierClean',
    component: () => import('@/views/mobile/supplierClean/index.vue'),
    meta: {
      title: '供方服务报告-万净',
      white: true,
      keepAlive: true,
    },
  },
  {
    path: '/supplierClean/personDetail',
    component: () => import('@/views/supplierClean/detail.vue'),
    meta: {
      title: '人工工时详情',
      white: true,
    },
  },
  {
    path: '/supplierClean/deviceDetail',
    component: () => import('@/views/supplierClean/detail.vue'),
    meta: {
      title: '设备工时详情',
      white: true,
    },
  },
  // 供方服务报告-万御
  {
    path: '/supplierSafety',
    name: 'supplierSafety',
    component: () => import('@/views/mobile/supplierSafety/index.vue'),
    meta: {
      title: '供方服务报告-万御',
      white: true,
      keepAlive: true,
    },
  },
   {
    path: '/largeScreenShow',
    name: 'largeScreenShow',
    component: () => import('@/views/largeScreenShow/index.vue'),
    meta: {
      title: '小区综合信息发布后台-大屏',
      white: true,
       keepAlive: true,
    },
  }
];

const router = new VueRouter({
  routes,
});
export default router;
